import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import CommissionDetails from './Commission';
import PollDetails from './Poll';
import StatusDetails from './Status';
import JournalDetails from './Journal';
import LiteratureDetails from './Literature';
import TierDetails from './Tier';
import DefaultDetails from './Default';
export const Details = (props)=>{
    const deviationType = getDeviationType(props.deviation);
    switch(deviationType){
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionDetails, _extends({}, props));
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(PollDetails, _extends({}, props));
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(StatusDetails, _extends({}, props));
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalDetails, _extends({}, props));
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(LiteratureDetails, _extends({}, props));
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierDetails, _extends({}, props));
        default:
            return /*#__PURE__*/ React.createElement(DefaultDetails, _extends({}, props));
    }
};
Details.displayName = 'Details';
export default Details;
